import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { PontuacaoBeneficio } from './pontuacao-beneficio';
import { Pontuacao } from './pontuacao';


@Component({
    templateUrl: './pontuacao-beneficio.component.html',
    selector: 'pontuacao-beneficio'
})
export class PontuacaoBeneficioComponent {

    public isLoading: boolean;
    private bolsaAlimentacaoAceito;
    @Input() beneficio: PontuacaoBeneficio;
    @Input() mostrarJustificativa: boolean = true;
    @Input() pontuacao: Pontuacao;
    @Input() mostrarBotao: boolean = true;
    @Output() beneficioEmitido: EventEmitter<PontuacaoBeneficio> = new EventEmitter<PontuacaoBeneficio>();

    // construtor
    constructor(
      public mensagem: MatSnackBar) {   }

    // ngOnInit é executado ao entrar na tela
    ngOnInit() {
      if(!this.beneficio.codigoPontuacao){
         if(this.pontuacao.rendaPerCapta > 1.5){
           this.beneficio.negado = true;
           this.beneficio.justificativaNegacao = "NPPAES";
         }else{
           // tem uma regra que fala que renda < 1.5 entra automatico no bolsa alimentação.
           if (this.beneficio.nomeUnicoOpcao ==  "sae_bolsa_alimentacao_gra" || this.beneficio.nomeUnicoOpcao ==  "sae_bolsa_alimentacao_pos") {
                this.beneficio.negado = false;
                this.bolsaAlimentacaoAceito= true;
           }
         }
      }
    }

    conceder(){
      if(!this.beneficio.codigoPontuacao && this.pontuacao.rendaPerCapta <= 1.5){
        this.beneficio.negado = false;
        this.beneficioEmitido.emit(this.beneficio);
      }
    }

    negar(){
      // soh pode negar na primeira vez, quando nao tem Código Pontuação
      if(!this.beneficio.codigoPontuacao){
        // se chegar com bolsa alimentação aceito, entao nao pode mudar
        if(!this.bolsaAlimentacaoAceito){
          this.beneficio.negado = true;
          this.beneficioEmitido.emit(this.beneficio);
        }
      }
    }

    // mostra erros na tela
   erro(erro: string){
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading= false;
   }



}
